export enum GiftCodeEntitlementValueType {
    Value = 0,
    Percentage = 1,
    NumberOfEntitlements = 2
}
